package com.vamvisions.main.portfolio.domain.model

/** A technology or tool. [description] is localized and [url] is absolute. */
data class Skill(
    val slug: String,
    val name: String,
    val description: String,
    val url: String,
)
